export const handleTimePsikotest = (psikotest_date) => {
  if (!psikotest_date) return false;
  const hourLimit = 3600000;
  const psikotestDate = new Date(psikotest_date).getTime();
  const now = Date.now();
  const calc_time = now - psikotestDate;
  if (calc_time >= 0) {
    return false;
  } else if (calc_time >= hourLimit) {
    return false;
  } else {
    return true;
  }
};
